import { SupportMatrixMemo } from "../supportMatrix";

export const BrowsePage = () => {
  return <SupportMatrixMemo />;
};
